import { useCurrentUser } from '../user';

import { usePeoPayrollProviderStaff } from './usePeoPayrollProviderStaff';

export const useCurrentPeoPayrollProviderStaff = () => {
  const { user } = useCurrentUser();
  const { peoPayrollProviderStaff, loading } = usePeoPayrollProviderStaff(
    user?.peoPayrollProviderStaff?.id,
  );

  const peoPayrollProviderStaffId = peoPayrollProviderStaff?.id;
  const peoPayrollProviderId = peoPayrollProviderStaff?.peoPayrollProvider.id;

  return {
    peoPayrollProviderStaffId,
    peoPayrollProviderStaff,
    peoPayrollProviderId,
    loading,
  };
};
